<template>
  <div class="page-wrap">
    <div class="page-content">
      <div class="page-header">渠道管理</div>
      <!-- <div v-show="showConf" class="plat-wrap">
        <div class="page-header">渠道管理</div>
        <el-button class="btn" plain>媒体平台</el-button>
        <ul class="plat-list">
          <li class="plat-item" @click="showConfDetail(1)">
            <img class="img" src="../../../assets/jlyq.png" />
          </li>
          <li class="plat-item" @click="showConfDetail(2)">
            <img class="img" src="../../../assets/txad.png" />
          </li>
          <li class="plat-item" @click="showConfDetail(3)">
            <img class="img" src="../../../assets/kuaishou.png" />
          </li>
        </ul>
      </div> -->
      <div v-show="!showConf" class="content-wrap">
        <div class="page-header">
          <el-select v-model="curPlatType" placeholder="请选择" @change="changePlatType">
            <el-option
              v-for="item in platTypeList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
              <div style="line-height: 46px; display: flex">
                <svg-icon
                  :iconClass="item.icon"
                  className="menu-icon"
                  style="font-size: 24px; margin-top: 5px"
                ></svg-icon>
                <div style="line-height: 32px; margin-left: 8px">
                  {{ item.label }}
                </div>
              </div>
            </el-option>
          </el-select>
          <el-select
            v-model="pkg"
            filterable
            placeholder="请选择产品"
            style="margin-left: 24px; width: 400px"
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.appName + '（' + item.pkg + '）'"
              :value="item.pkg"
            >
              <div>
                {{ item.appName }}<span v-if="item.pkg">（{{ item.pkg }}）</span>
              </div>
            </el-option>
          </el-select>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="归因配置" name="gy">
            <attr-conf :params="{ pkg, curPlatType }"></attr-conf>
          </el-tab-pane>
          <el-tab-pane label="回调配置" name="hd">
            <callback-conf :params="{ pkg, curPlatType }"></callback-conf>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import AttrConf from "./attrConf.vue";
import CallbackConf from "./callbackConf.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import { getConvertProductList } from "@/api/api.js";
export default {
  name: "ChannelConf",
  components: {
    AttrConf,
    CallbackConf,
    SvgIcon,
  },
  data() {
    return {
      platTypeList: [
        { label: "今日头条", value: 1, icon: "jrtt" },
        { label: "广点通", value: 2, icon: "gdt" },
        { label: "快手", value: 3, icon: "kuaishou" },
        { label: "OPPO", value: 20, icon: "oppo" },
      ],
      showConf: false,
      confName: "",
      activeName: "gy",
      curPlatType: "", //platType：1-头条，2-广点通，3-快手(还没接)，4-星图
      pkg: "",
      productList: [],
    };
  },
  methods: {
    showConfDetail(platType) {
      this.curPlatType = platType;
      switch (platType) {
        case 1:
          this.confName = "巨量引擎";
          break;
        case 2:
          this.confName = "腾讯广告";
          break;
        case 3:
          this.confName = "快手";
          break;
        case 4:
          this.confName = "巨量星图";
          break;
        default:
          this.confName = "-";
          break;
      }
      this.showConf = true;
    },
    changePlatType() {
      getConvertProductList({
        platType: this.curPlatType,
      }).then((res) => {
        if (res.code === "0000") {
          this.productList = res.data;
          if (this.productList.length > 0) {
            this.pkg = this.productList[0].pkg || "com.pdragon.new2048.tg";
          } else {
            this.pkg = "";
          }
        }
      });
    },
  },
  mounted() {
    this.curPlatType = 1;
    this.changePlatType();
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  .page-content {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    height: 100%;
    padding: 16px 24px;
    .page-header {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
    }
    .plat-wrap {
      padding: 16px 24px;
      .btn {
        color: rgba(24, 144, 255, 1);
        border-color: rgba(24, 144, 255, 1);
        margin: 16px 0;
      }
      .plat-list {
        margin: 0px;
        padding: 0px;
        list-style: none;
        display: flex;
        .plat-item {
          width: 162px;
          height: 86px;
          cursor: pointer;
          margin-right: 12px;
          overflow: hidden;
          .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 0.4s;
            &:hover {
              transform: scale(1.2);
            }
          }
        }
      }
    }
    .content-wrap {
      .page-header {
        padding: 16px 24px 10px 0px;
        .header-text {
          color: rgba(0, 0, 0, 0.85);
          font-weight: bold;
          font-size: 15px;
          cursor: pointer;
        }
      }
      /deep/ .el-tabs__nav {
        margin-left: 24px;
      }
    }
  }
}
</style>
